/* eslint-disable camelcase */
import { CLIENT_IDS } from '../../../utilities/oauth/constants';
import { EXTERNAL_APPS } from '../constants';

export const defaultSignInProviders = {
  idme: true,
  logingov: true,
  clear: true,
};

export const defaultMobileQueryParams = {
  allowOAuth: true,
  allowPostLogin: false,
  allowRedirect: false,
};

export const defaultForcedVerifyAcr = {
  acr: {
    idme: 'urn:acr.va.gov:verified-facial-match-preferred',
    logingov: 'urn:acr.va.gov:verified-facial-match-preferred',
    clear: 'urn:acr.va.gov:verified-facial-match-preferred',
  },
};

export const defaultMobileOAuthOptions = {
  clientId: CLIENT_IDS.VAMOBILE,
  acr: {
    idme: 'urn:acr.va.gov:verified-facial-match-preferred',
    logingov: 'urn:acr.va.gov:verified-facial-match-preferred',
    clear: 'urn:acr.va.gov:verified-facial-match-preferred',
  },
  acrSignup: {
    idme_signup: 'urn:acr.va.gov:verified-facial-match-required',
    logingov_signup: 'urn:acr.va.gov:verified-facial-match-required',
    clear_signup: 'urn:acr.va.gov:verified-facial-match-required',
  },
};

export const defaultWebOAuthOptions = {
  clientId: CLIENT_IDS.VAWEB,
  acr: { idme: 'min', logingov: 'min', clear: 'min' },
  acrSignup: {
    idme_signup: 'min',
    logingov_signup: 'min',
    clear_signup: 'min',
  },
  acrVerify: { idme: 'loa3', logingov: 'ial2', clear: 'ial2' },
};

export const arpWebOAuthOptions = {
  clientId: CLIENT_IDS.ARP,
  acr: { idme: 'loa3', logingov: 'ial2', clear: 'ial2' },
  acrSignup: {
    idme_signup: 'loa3',
    logingov_signup: 'ial2',
    clear_signup: 'ial2',
  },
};

export const OAuthEnabledApplications = [
  undefined /* default */,
  EXTERNAL_APPS.VA_FLAGSHIP_MOBILE,
  EXTERNAL_APPS.ARP,
  EXTERNAL_APPS.MY_VA_HEALTH,
];
